import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { CalendarioComponent } from './pages/calendario/calendario.component';
import { CentrosComponent } from './pages/centros/centros.component';
import { AreaComponent } from './pages/area/area.component';
import { ArticuloComponent } from './pages/articulo/articulo.component';
import { ProyectoComponent } from './pages/proyecto/proyecto.component';
import { EventoComponent } from './pages/evento/evento.component';
import { BosniArticuloComponent } from './pages/bosni-articulo/bosni-articulo.component';


import { RecursoEducativoComponent } from './pages/recurso-educativo/recurso-educativo.component';
import { RecursoFormularioComponent } from './pages/recurso-formulario/recurso-formulario.component';
import { ContactoComponent } from './pages/contacto/contacto.component';

import { GameLaunchComponent } from './pages/game-launch/game-launch.component';
import { GameMainComponent } from './pages/game-main/game-main.component';
import { GameTriviaComponent } from './pages/game-trivia/game-trivia.component';
import { TriviaComponent } from './pages/trivia/trivia.component';
import { GameGlossaryComponent } from './pages/game-glossary/game-glossary.component';
import { GameAboutComponent } from './pages/game-about/game-about.component';
import { GameResourcesComponent } from './pages/game-resources/game-resources.component';
import { LoginComponent } from './components/login/login.component';
import { GameCreateComponent } from './pages/game-create/game-create.component';
import { TermsComponent } from './pages/terms/terms.component';
import { TermsCookiesComponent } from './pages/terms-cookies/terms-cookies.component';
import { TermsPrivacyComponent } from './pages/terms-privacy/terms-privacy.component';

const routes: Routes = [
  //{ path: '**', pathMatch: 'full', redirectTo: 'home' },
  { path: '', component: HomeComponent },

  { path: 'calendario/:context', component: CalendarioComponent },
  { path: 'evento/:url', component: EventoComponent },
  { path: 'centros/:url', component: CentrosComponent },

  { path: 'area-protegida/:url', component: AreaComponent },

  { path: 'proyecto-en-imagenes/:context', component: ProyectoComponent },
  { path: 'articulo/:url', component: ArticuloComponent },

  { path: 'recursos-didacticos/:collection/:context', component: RecursoEducativoComponent },
  { path: 'recurso-bosni/:url', component: BosniArticuloComponent },
  { path: 'recursos-formulario/:id', component: RecursoFormularioComponent },

  { path: 'contacto', component: ContactoComponent },

  { path: 'conoce-la-naturaleza', component: GameMainComponent },//
  { path: 'juego-inicio/:game', component: GameLaunchComponent },//
  { path: 'juego-info/:game/:url', component: GameAboutComponent },//
  { path: 'juego-trivia/:game', component: GameTriviaComponent },//
  { path: 'trivia/:game/:category', component: TriviaComponent },
  { path: 'juego-glosario/:game/:category', component: GameGlossaryComponent },//
  { path: 'juego-recursos/:game/:url', component: GameResourcesComponent },//
  { path: 'juego-crear', component: GameCreateComponent },
  { path: 'login', component: LoginComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'terms-privacy', component: TermsPrivacyComponent},
  { path: 'terms-cookies', component: TermsCookiesComponent },

 // import { GameLaunchComponent } from './pages/game-launch/game-launch.component';
 // import { GameMainComponent } from './pages/game-main/game-main.component';
 // import { GameTriviaComponent } from './pages/game-trivia/game-trivia.component';
 // import { GameGlossaryComponent } from './pages/game-glossary/game-glossary.component';
 // import { GameAboutComponent } from './pages/game-about/game-about.component';
 // import { GameResourcesComponent } from './pages/game-resources/game-resources.component';


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
